import { AIAgentsClient } from "@amazon-connect/ai-agents";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** AIAgentsClient: AI agent messaging and knowledge content. */
export const aiAgentsModule: ClientModule = {
  id: "ai-agents",
  label: "AI Agents",
  pkg: "@amazon-connect/ai-agents",
  clientExport: "AIAgentsClient",
  kind: "observable",
  create: (provider: AmazonConnectProvider) =>
    new AIAgentsClient({ provider }) as unknown as Record<string, unknown>,
  events: [
    // contactId is REQUIRED here (unlike every other contactId?-scoped event in the registry) —
    // omitting it means the SDK keys the subscription on undefined and the handler never fires.
    {
      name: "onAIAgentContactReady",
      off: "offAIAgentContactReady",
      args: [{ k: "contactId", type: "contactId", required: true }],
    },
    { name: "onAIAgentMessageReceived", off: "offAIAgentMessageReceived" },
    {
      name: "onAIAgentMessageStatusChanged",
      off: "offAIAgentMessageStatusChanged",
    },
  ],
  requests: [
    { name: "isAIAgentSupported", args: [] },
    // listAIAgentMessages(params: ListAIAgentMessagesParams) — a params object, not a bare contactId.
    {
      name: "listAIAgentMessages",
      args: [{ k: "params", type: "json", required: true }],
    },
    {
      name: "getKnowledgeContent",
      args: [{ k: "params", type: "json", required: true }],
    },
    {
      name: "sendAIAgentMessage",
      args: [{ k: "params", type: "json", required: true }],
      mutating: true,
    },
  ],
};
